var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","id":"add-song-button"},on:{"click":_vm.addSong}},[_c('IconPlus'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('song.addToSongbook')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }